<template>
  <div class="exam-warp">
    <div class="exam-title">
      <div class="exam-name">{{exam.exam_name}}</div>
    </div>
    <div class="exam-body">
      <div class="left-panel">
        <div class="panel-title">
          答题卡 （共{{questions.length}}题）
        </div>
        <div class="panel-body">
          <div class="body-bar">
            已答<span style="background-color: #2152af;border-color: #2152af;"></span>
            当前<span></span>未答<span style="border-color: #999;"></span>
          </div>
          <div class="body-context">
            <div v-if="questions_sel.length > 0" class="answer-sheet">
                <div class="answer-sheet-title">单项选择题（共{{questions_sel.length}}题)</div>

                <div v-for="item in questions_sel" :key="item.que_gid"
                     :class="item.num_class" @click="questionClick(item)">{{item.index}}</div>
            </div>

            <div v-if="questions_sel_all.length > 0" class="answer-sheet">
                <div class="answer-sheet-title">多项选择题（共{{questions_sel_all.length}}题)</div>

                <div v-for="item in questions_sel_all" :key="item.que_gid"
                     :class="item.num_class"  @click="questionClick(item)">{{item.index}}</div>
            </div>

            <div v-if="questions_bool.length > 0" class="answer-sheet">
                <div class="answer-sheet-title">判断题（共{{questions_bool.length}}题)</div>

                <div v-for="item in questions_bool" :key="item.que_gid"
                     :class="item.num_class"  @click="questionClick(item)">{{item.index}}</div>
            </div>

            <div v-if="questions_fill.length > 0" class="answer-sheet">
                <div class="answer-sheet-title">填空题（共{{questions_fill.length}}题)</div>

                <div v-for="item in questions_fill" :key="item.que_gid"
                     :class="item.num_class"  @click="questionClick(item)">{{item.index}}</div>
            </div>

            <div v-if="questions_code.length > 0" class="answer-sheet">
                <div class="answer-sheet-title">编程题（共{{questions_code.length}}题)</div>

                <div v-for="item in questions_code" :key="item.que_gid"
                     :class="item.num_class"  @click="questionClick(item)">{{item.index}}</div>
            </div>

          </div>

          <div class="body-foot">
              <div v-if="!examFinish" class="submit-but" @click="eventDialogOpen">我要交卷</div>
              <div v-if="examFinish" class="submit-but" >考试已结束</div>
          </div>

        </div>
      </div>
      <div class="center-panel">
        <div class="panel-title">
          第{{question.index}}题：{{question.exam_que_cate}}
        </div>
        <div class="panel-body1" v-html="get_que_context"  v-img-rewrite>
        </div>
      </div>
      <div class="right-panel">
        <div class="panel-title">
          作答区
        </div>
        <div class="panel-body2">

          <div v-if="question.exam_que_cate == '选择题'" class="sel-que">
            <div v-for="item in question.optionVal" :key="item.key" class="sel-row">
              <input v-if="question.user_answer == item.key" type="radio" checked name="identity" @click="answerClick(item.key)">
              <input v-if="question.user_answer != item.key" type="radio" name="identity" @click="answerClick(item.key)">
              <div class="sel-key">{{item.key}}、</div> <div v-html="item.key_context" v-img-rewrite></div>
            </div>
          </div>

          <div v-if="question.exam_que_cate == '多选题'" class="sel-que">
            <div v-for="item in question.optionVal" :key="item.key" class="sel-row">
              <input v-if="checkKey(item.key)" type="checkbox" checked name="identity" @click="answerClickAll(false,item.key)">
              <input v-if="!checkKey(item.key)" type="checkbox" name="identity" @click="answerClickAll(true,item.key)">
              <div class="sel-key">{{item.key}}、</div> <div v-html="item.key_context" v-img-rewrite></div>
            </div>
          </div>

          <div v-if="question.exam_que_cate == '判断题'" class="bool-que">
            <div class="sel-row">
              <input v-if="question.user_answer == '正确'" type="radio" checked name="identity" @click="answerClickBool('正确')">
              <input v-if="question.user_answer != '正确'" type="radio" name="identity" @click="answerClickBool('正确')">
              <div class="sel-key"></div> <div>正确</div>
            </div>
            <div class="sel-row">
              <input v-if="question.user_answer == '错误'" type="radio" checked name="identity" @click="answerClickBool('错误')">
              <input v-if="question.user_answer != '错误'" type="radio" name="identity" @click="answerClickBool('错误')">
              <div class="sel-key"></div> <div>错误</div>
            </div>
          </div>


          <div v-if="question.exam_que_cate == '填空题'" >
            <div class="sel-row">
              <input type="text" v-model="question.user_answer" placeholder="请输入答案" class="input-answer">
            </div>
          </div>

          <div v-if="question.exam_que_cate == '编程题'" >
            <div class="sel-row">
              <div class="code-but" @click="openCodeEditer">点击作答>></div>
            </div>
          </div>

          <div v-if="examFinish && question != '编程题'" class="sel-que" style="font-weight: 600; margin-top: 20px">
            <div>正确答案:</div>
            <div>{{question.exam_que_answer}}</div>
          </div>



        </div>
        <div class="body-foot">
          <div class="up-but" @click="previousClick(question.index-1, question.exam_que_cate)">上一题</div>
          <div class="down-but" @click="nextClick(question.index+1, question.exam_que_cate)" style="background-color: #387DFE; color: white;">下一题</div>
        </div>
      </div>
    </div>

    <DialogPanel wth="350" hth="210" title="试卷提交"
                 :dialog-state="dialogState"
                 @event-dialog-close="eventDialogClose">
      <div class="dialog-context">确认交卷吗？一旦交卷就不能再作答或修改答案啦！</div>
      <div class="dialog-foot">
        <div class="dialog-but"
             @click="submitExam">确定提交</div>
        <div class="dialog-but"
             @click="eventDialogClose"
             style="background-color: #387DFE; color: white;">继续答题</div>
      </div>
    </DialogPanel>

    <modalImage :image-url="imageUrl" ref="modalImage"></modalImage>
  </div>
</template>

<script>
import modalImage from "@/components/panel/modalImage";
import DialogPanel from "@/components/panel/dialogPanel";
import serviceApi from "@/utils/serviceApi";
import utils from "@/utils/utils";
import Cookies from 'js-cookie'
let that = undefined;
export default {
  name: "examView",
  components: {DialogPanel,modalImage},
  directives:{
    imgRewrite: {
        // 指令的定义
        updated: function (el) {
          const imgs = el.querySelectorAll('img');
          imgs.forEach(img => {
            img.onclick = function () {
              that.imgClick(img.src);
            }
          });
        }
    }
  },
  data(){
    return{
      dialogState: false,
      examFinish: false,
      imageUrl:"",
      exam:{},
      questions:[],
      question:{index:0},
      questions_sel:[],
      questions_sel_all:[],
      questions_bool:[],
      questions_fill:[],
      questions_code:[]
    }
  },
  computed:{
    get_que_context: function (){

      let result = ""
      if(this.question.exam_que_context != undefined) {
        try{
          if(this.question.exam_que_cate == "编程题"){
            result = this.question.exam_que_context;
          }else{
            result = this.question.exam_que_context;
          }
        } catch (err){
          result = err;
        }
      }
      console.log(result);
      return result;
    }
  },
  methods: {
    //图片放大
    imgClick: function (imgsrc){
      this.imageUrl = imgsrc;
      this.$refs.modalImage.openModal();
    },
    //编程题
    openCodeEditer:function (){
      let que_gid = this.question.que_gid;
      let vip_gid = utils.GetQueryString("vip_gid");
      if(vip_gid == ""){
        vip_gid = Cookies.get('guid');
      }
      if(this.question.exam_que_answer == "Scratch"){
        window.open("/build/index.html?pid=" + que_gid + "&uid=" + vip_gid,"scratch");
      }else{
        window.open("/Admin/WebIDE/webide.aspx?pid=" + que_gid + "&uid=" + vip_gid,"code");
      }
    },
    eventDialogOpen: function (){
      this.dialogState = true;
    },
    eventDialogClose: function (){
      this.dialogState = false;
    },
    checkKey: function (key){
      if(this.question.user_answer.indexOf(key) !== -1){
        return true;
      }else{
        return false;
      }
    },
    //多选题答题
    answerClickAll: function (checked, answer){
      if(this.examFinish){
        return;
      }
      let user_answer= this.question["user_answer"]
      if(checked){
        user_answer = user_answer + answer;
      }else{
        user_answer = user_answer.replace(answer, "")
      }
      let arr = user_answer.split("");
      arr.sort();
      user_answer = arr.join("");
      this.question["user_answer"] = user_answer;
    },
    //判断题答题
    answerClickBool: function (answer){
      if(this.examFinish){
        return;
      }
      this.question["user_answer"] = answer;
      this.question["num_class"] = "num-box num-box-ok";
    },
    //单选题答题
    answerClick: function (key){
      if(this.examFinish){
        return;
      }
      this.question["user_answer"] = key;
      this.question["num_class"] = "num-box num-box-ok";
    },
    //选题
    questionClick: function (question){
      if(this.examFinish){
        this.question = question;
        return;
      }
      if(this.question["user_answer"] == ""){
        this.question["num_class"] = "num-box";
      }else{
        this.question["num_class"] = "num-box num-box-ok";
      }

      this.question = question;
      this.question["num_class"] = "num-box num-box-sel";

    },
    //上一题
    previousClick: function (index, exam_que_cate){
      let questions = this.questions;
      for(let i = 0; i < questions.length; i++){
        if(questions[i].exam_que_cate == exam_que_cate && questions[i].index == index) {
          //选题
          this.questionClick(questions[i]);
          break;
        }
      }
    },
    //下一题
    nextClick: function (index, exam_que_cate){
      this.previousClick(index, exam_que_cate);
    },

    getQuestions: function (exam_que_cate){
      let index = 1;
      let questions = this.questions;
      let result = [];

      for(let i = 0; i < questions.length; i ++){
        if(questions[i].exam_que_cate == exam_que_cate){
          questions[i]["user_answer"] = questions[i]["vip_answer"];
          questions[i]["index"] = index;
          result.push(questions[i])
          index = index + 1;
        }
      }
      return result;
    },
    //设计数字框的状态
    setNumboxClass: function (questions){
      for(let i = 0; i < questions.length; i ++){
        if(questions[i].exam_que_cate == "编程题"){
          questions[i]["num_class"] = "num-box";
        }else{
          if(questions[i].vip_answer == ""){
            questions[i]["num_class"] = "num-box";
          }else{
            if(this.examFinish){
              if(questions[i].vip_answer == questions[i].exam_que_answer){
                questions[i]["num_class"] = "num-box num-box-yes";
              }else{
                questions[i]["num_class"] = "num-box num-box-no";
              }
            }else{
              questions[i]["num_class"] = "num-box num-box-ok";
            }
          }
        }
      }
    },
    //获取试题
    fabuCallback: function (data){
      this.questions = data;
      this.questions_sel = this.getQuestions("选择题");
      this.questions_sel_all = this.getQuestions("多选题");
      this.questions_fill = this.getQuestions("填空题");
      this.questions_bool = this.getQuestions("判断题");
      this.questions_code = this.getQuestions("编程题");

      this.examFinish = true;
      for(let i = 0; i < this.questions.length; i ++){
        if(this.questions[i].exam_que_cate != "编程题"){
          if(this.questions[i]["vip_answer"] == ""){
            this.examFinish = false;
          }
        }
      }

      this.setNumboxClass(this.questions);

      if(this.questions_sel.length > 0){
        this.questionClick(this.questions_sel[0]);
      }
    },
    //提交试卷
    submitExam: function (){
      let Params = {"exam_answer":[]};
      let questions = this.questions;
      for(let i = 0; i < questions.length; i ++){
        if(questions[i].exam_que_cate != "编程题"){
          questions[i].vip_answer = questions[i].user_answer;
          if(questions[i].user_answer != ""){
            Params.exam_answer.push({
              "key": questions[i].gid,
              "value": questions[i].user_answer
            })
          }
        }
      }
      serviceApi.ExamFabuUpdate(Params,(res)=>{
        this.dialogState = false;
        this.examFinish = true;
        this.setNumboxClass(this.questions);
        console.log(res);
      })
    }
  },
  mounted() {
    that = this;
    serviceApi.ExamQuery({},(res)=>{
      if(res.rows.length > 0){
        this.exam = res.rows[0];
      }
    });
    serviceApi.ExamFabu({}, this.fabuCallback);
  }
}
</script>

<style scoped>
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 12px; /* 设置滚动条的宽度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 设置滚动条轨道的颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: #e2dede; /* 设置滚动条滑块的颜色 */
}

/* 当鼠标悬停在滑块上 */
::-webkit-scrollbar-thumb:hover {
  background: #e2dddd; /* 设置滚动条滑块在悬停状态下的颜色 */
}
::v-deep img{
    max-width:90%;
}
.exam-warp{
  display: flex;
  flex-direction: column;
  justify-content: start;
  background-color: #387DFE;
  height: 100vh;
}
.exam-title{
  height: 70px;
  margin: 10px;
  background-color: #EBF5FF;
  border-radius: 15px;
  box-shadow: 2px 2px 2px #2152af;
}
.exam-name{
  height: 70px;
  line-height: 70px;
  font-size: 24px;
  font-weight: 600;
  padding-left: 30px;
}
.exam-body{
  height: calc(100vh - 110px);
  display: flex;
  flex-direction: row;
  justify-content: start;
  margin: 5px;
}
.left-panel{
  width: 25%;
  height: 100%;
  background-color: #ffffff;
  margin: 5px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  box-shadow: 2px 2px 2px #2152af;
}
.center-panel{
  width: 40%;
  height: 100%;
  background-color: #ffffff;
  margin: 5px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  box-shadow: 2px 2px 2px #2152af;
}
.right-panel{
  width: 35%;
  height: 100%;
  background-color: #ffffff;
  margin: 5px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  box-shadow: 2px 2px 2px #2152af;
}
.panel-title{
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #EBF5FF;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  padding-left: 20px;
  font-size: 20px;
  box-sizing: border-box;
}
.panel-body{
  width: 100%;
  height: calc(100% - 110px);
}

.panel-body1{
  box-sizing: border-box;
  width: 100%;
  height: calc(100% - 60px);
  overflow-x: hidden;
  overflow-y: auto;
  font-weight: 400;
  line-height: 30px;
  font-size: 20px;
  padding: 10px 20px
}


.panel-body2{
  box-sizing: border-box;
  width: 100%;
  height: calc(100% - 110px);
  overflow-x: hidden;
  overflow-y: auto;
  font-weight: 400;
  line-height: 30px;
  font-size: 16px;
  padding: 10px 20px
}

.body-bar{
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  margin-bottom: 20px;
}
.body-bar span{
  display: block;
  width: 10px;
  height: 10px;
  border: 1px solid red;
  margin: 10px 5px;
}
.body-context{
  width: 100%;
  height: calc(100% - 60px);
  padding-top: 10px;
  overflow-y: auto;
}
.answer-sheet{
  position: relative;
  display: block;
  min-height: 80px;
  margin: 5px 20px;
  border: 1px solid #d0dbe7;
  box-sizing: border-box;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 30px;
}
.answer-sheet-title{
  position: absolute;
  top: -12px;
  left: 30px;
  background-color: #f2f2f2;
  padding: 1px 10px;
  border-radius: 10px;
}
.num-box{
  display: inline-block;
  margin: 10px;
  width: 22px;
  height: 22px;
  line-height: 22px;
  border: 1px solid #d0dbe7;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}
.num-box-ok{
  border: 1px solid #2152af;
  background-color: #2152af;
  color: white;
}

.num-box-sel{
  border: 1px solid red;
}

.num-box-yes{
  background-image: url("../../assets/ok.png");
  background-size: 100% 100%;
  border-radius: 10px;
}

.num-box-no{
  background-image: url("../../assets/err.png");
  background-size: 100% 100%;
  border-radius: 10px;
}

.body-foot{
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 50px;
  width: 100%;
  text-align: center;

}
.submit-but{
  background-color: #387DFE;
  color: white;
  width: 200px;
  text-align: center;
  margin: 10px auto;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  font-size: 20px;
  padding: 0px;
  cursor: pointer;
}
.up-but, .down-but{
  display: inline-block;
  margin: 10px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #d0dbe7;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
}

.sel-row{
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}
.sel-row .sel-key {
  margin: auto 10px;
}
.sel-row .input-answer{
  outline-style: none ;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px 14px;
  width: 200px;
  font-size: 16px;
}
.sel-row .code-but{
  display: block;
  margin: 50px;
  width: 150px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #d0dbe7;
  border-radius: 10px;
  text-align: center;
  background-color: #f2f2f2;
  cursor: pointer;
}

.dialog-context{
  padding: 25px 20px;
  font-size: 20px;
  font-weight: 400;
  color: #666666;
}
.dialog-foot{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 50px;
  height: 60px;
  line-height: 60px;
}
.dialog-but{
  display: block;
  margin: 5px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #d0dbe7;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
}


</style>
